// extracted by mini-css-extract-plugin
export default {"wrapper":"L1-z","play":"M1-z"};